export const CONNECTOR_CAMERA_POLICY = 'PHONE_SCANS_BROWSER' as const;
export const MAX_OFFER_TTL_MS = 120_000 as const;
